export * from './active-locale';
